var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.totalVisitsCounts, loading: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "block w-full mb-6" },
            [
              _c("RadioButtonGroup", {
                attrs: { options: _vm.radioOptions },
                model: {
                  value: _vm.currentVisitTab,
                  callback: function ($$v) {
                    _vm.currentVisitTab = $$v
                  },
                  expression: "currentVisitTab",
                },
              }),
            ],
            1
          ),
          _vm.currentVisitTab === _vm.visitStatus.OFFERED
            ? _c("OfferedVisits", {
                attrs: {
                  currentUser: _vm.currentUser,
                  company: _vm.company,
                  isWithActivities: "",
                  hideDescription: "",
                },
              })
            : _vm._e(),
          _vm.currentVisitTab === _vm.visitStatus.ACCEPTED
            ? _c("AcceptedVisits", {
                attrs: {
                  currentUser: _vm.currentUser,
                  company: _vm.company,
                  isWithActivities: "",
                  hideDescription: "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }